export default __webpack_public_path__ + "static/media/mc_img_03.8a249ebe.png";